(function () {
    'use strict';

    angular
        .module('salesflare')
        .factory('conferencesyncprogress', conferenceSyncProgressFactory);

    function conferenceSyncProgressFactory($interval, $window, me, model, statusBarService, $translate, $exceptionHandler) {

        let stop;
        let readMoreUrl = 'https://howto.salesflare.com/';

        function getText(status) {
            const textMap = {
                initial: $translate.instant('Looking for AI notes & transcripts...'),
                sync: $translate.instant('Looking for AI notes & transcripts...'),
                error: $translate.instant('No AI notes & transcripts found. Make sure to set this up in your meeting tool account.'),
                done_no_transcripts_found: $translate.instant('No AI notes & transcripts found. Make sure to set this up in your meeting tool account.'),
                done: $translate.instant('Successfully synced AI notes & transcripts.')
            };

            return textMap[status];
        }

        return {
            startPolling,
            stopPolling
        };

        function stopPolling() {

            if (stop) {
                $interval.cancel(stop);
                stop = undefined;
            }

        }

        function startPolling(options) {

            if (options && options.readMoreUrl) {
                readMoreUrl = options.readMoreUrl;
            }

            statusBarService.show({
                type: 'conference',
                text: getText('initial')
            });

            if (stop) {
                doPoll();
            }
            else {
                doPoll();
                stop = $interval(doPoll, 5 * 1000);
            }
        }

        function doPoll() {

            return me.get().then(function (response) {

                if (!model.me) {
                    statusBarService.hide('conference');
                    return stopPolling();
                }

                model.me.conference_sync_status = response.data.conference_sync_status;

                if (!model.me.conference_sync_status) {
                    return statusBarService.show({
                        type: 'conference',
                        text: getText('initial')
                    });
                }

                if (model.me.conference_sync_status === 'done') {
                    stopPolling();

                    return statusBarService.show({
                        type: 'conference',
                        text: getText(model.me.conference_sync_status),
                        showSpinner: false,
                        canClose: true,
                        class: 'success'
                    });
                }
                else if (model.me.conference_sync_status === 'error') {
                    const statusBar = {
                        type: 'conference',
                        text: getText(model.me.conference_sync_status),
                        showSpinner: false,
                        canClose: true,
                        class: 'warning',
                        linkText: $translate.instant('Read more'),
                        onLinkClick: function () {

                            return $window.open(readMoreUrl, '_blank', 'noopener');
                        }
                    };

                    stopPolling();
                    return statusBarService.show(statusBar);
                }
                else if (model.me.conference_sync_status === 'done_no_transcripts_found') {
                    const statusBar = {
                        type: 'conference',
                        text: getText(model.me.conference_sync_status),
                        showSpinner: false,
                        canClose: true,
                        class: 'warning',
                        linkText: $translate.instant('Read more'),
                        onLinkClick: function () {

                            return $window.open(readMoreUrl, '_blank', 'noopener');
                        }
                    };

                    stopPolling();
                    return statusBarService.show(statusBar);
                }

                if (getText(model.me.conference_sync_status)) {
                    return statusBarService.show({
                        type: 'conference',
                        showSpinner: true,
                        text: getText(model.me.conference_sync_status)
                    });
                }

                // Not a valid sync_status (actual error or just not a valid one to show in the bar)
                $exceptionHandler(new Error('Unknown conference_sync_status: ' + model.me.conference_sync_status));
                statusBarService.hide('conference');
                return stopPolling();
            }).catch(function () {

                statusBarService.hide('conference');
                return stopPolling();
            });
        }
    }
})();
